import React from "react";

const fgColor = (v) => {
  if (v < 25) return "#ff3355";
  if (v < 45) return "#f5a623";
  if (v < 65) return "#fbbf24";
  if (v < 80) return "#86efac";
  return "#00e676";
};

/**
 * Bottom metrics bar: Funding · OI · Fear&Greed · Liquidations · BTC Dominance.
 */
export const MetricsFooter = ({ metrics }) => {
  const {
    funding = 0,
    openInterest = 1,
    fearGreed = 50,
    liquidations = 0,
    dominance = 50,
  } = metrics || {};

  const fgC = fgColor(fearGreed);

  return (
    <>
      {/* Mobile: horizontal scrolling row — keeps the order panel above the fold.
          Desktop: 5-column grid as before. */}
      <div
        className="flex gap-px overflow-x-auto rounded-2xl border border-white/10 bg-white/[0.04] text-[11px] md:grid md:grid-cols-5 md:overflow-visible"
        data-testid="sim-metrics-footer"
      >
        <Metric
          label="Funding rate"
          value={`${(funding * 100).toFixed(3)}%`}
          valueClass={funding >= 0 ? "text-emerald-300" : "text-rose-300"}
        />
        <Metric
          label="Open interest"
          value={openInterest >= 1 ? `↑ ${(openInterest * 100).toFixed(0)}%` : `↓ ${(openInterest * 100).toFixed(0)}%`}
          valueClass={openInterest >= 1 ? "text-cyan-300" : "text-amber-300"}
        />
        <div className="flex shrink-0 flex-col gap-1 bg-black/40 p-2.5 min-w-[140px] md:min-w-0 md:p-3">
          <span className="text-[9px] font-bold uppercase tracking-[0.22em] text-white/45">
            Fear &amp; Greed
          </span>
          <div className="flex items-center gap-2">
            <span className="font-mono text-sm font-bold md:text-base" style={{ color: fgC }}>
              {Math.round(fearGreed)}
            </span>
            <div className="relative h-1.5 flex-1 overflow-hidden rounded-full bg-white/10">
              <div
                className="absolute inset-y-0 left-0 rounded-full"
                style={{ width: `${Math.max(0, Math.min(100, fearGreed))}%`, background: fgC, boxShadow: `0 0 10px ${fgC}88` }}
              />
            </div>
          </div>
        </div>
        <Metric
          label="Liquidations (4h)"
          value={`$${(liquidations / 1000).toFixed(1)}M`}
          valueClass={liquidations > 500 ? "text-rose-300" : "text-white/85"}
        />
        <Metric
          label="BTC Dominance"
          value={`${dominance.toFixed(1)}%`}
          valueClass="text-white/85"
        />
      </div>
    </>
  );
};

const Metric = ({ label, value, valueClass = "text-white/85" }) => (
  <div className="flex shrink-0 flex-col gap-1 bg-black/40 p-2.5 min-w-[120px] md:min-w-0 md:p-3">
    <span className="text-[9px] font-bold uppercase tracking-[0.22em] text-white/45">{label}</span>
    <span className={`font-mono text-sm font-bold md:text-base ${valueClass}`}>{value}</span>
  </div>
);

export default MetricsFooter;
